import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Button } from '@/components/ui';
import { Search as SearchIcon } from '@mui/icons-material';
import { TRANSACTION_STATUSES } from '../../constants';
import type { TransactionFiltersProps } from '../../types';

export const TransactionFilters: React.FC<TransactionFiltersProps> = ({
  searchTerm,
  statusFilter,
  onSearchTermChange,
  onStatusFilterChange,
  onClearFilters,
}) => {
  return (
    <Box
      mb={3}
      display="flex"
      gap={2}
      alignItems="center"
      flexWrap="wrap"
      justifyContent="space-between"
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
        },
      }}
    >
      {/* Search Input */}
      <TextField
        variant="outlined"
        placeholder="Search "
        value={searchTerm}
        onChange={e => onSearchTermChange(e.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" sx={{ fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: 1,
          maxWidth: 450,
          '& .MuiOutlinedInput-root': {
            background: 'white',
          },
        }}
      />

      {/* Filter Controls */}
      <Box display="flex" gap={2} alignItems="center">
        {/* Status Filter */}
        <FormControl
          variant="outlined"
          size="small"
          sx={{
            minWidth: 180,
            '& .MuiOutlinedInput-root': {
              background: 'white',
            },
          }}
        >
          <InputLabel>Transaction Status</InputLabel>
          <Select
            value={statusFilter}
            onChange={e => onStatusFilterChange(e.target.value)}
            label="Transaction Status"
          >
            <MenuItem value="">All Status</MenuItem>
            {Object.entries(TRANSACTION_STATUSES).map(([key, value]) => (
              <MenuItem key={key} value={key}>
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Clear Filters Button */}
        <Button variant="outlined" size="small" onClick={onClearFilters}>
          Clear Filters
        </Button>
      </Box>
    </Box>
  );
};

export default TransactionFilters;
